import React from "react";

import { VideoEmbedBlock } from "@reactivated";

import styles from "./embed.module.scss";

export const VideoEmbed = ({ value }: { value: VideoEmbedBlock }) => {
    if (!value.embed_id) return;

    const url = new URL("https://www.youtube.com/");
    if (value.embed_type === "video") {
        url.pathname = `embed/${value.embed_id}`;
    } else {
        url.pathname = "embed";
        url.searchParams.append("listType", "playlist");
        url.searchParams.append("list", value.embed_id);
    }
    url.searchParams.append("controls", "0");
    url.searchParams.append("fs", "0"); // hide fullscreen button
    url.searchParams.append("rel", "0"); // only recommend related videos from the same channel
    url.searchParams.append("widget_referrer", "leanin.org");
    return (
        <div className={styles.root} style={{ "--aspect-ratio": 16 / 9 }}>
            {/* frameborder, allow, referrerpolicy copied verbatim from youtube */}
            <iframe
                src={url.toString()}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
            />
        </div>
    );
};
